import React, { useState } from "react";
import hermit from "../../assets/alltarotcards/hermit.jpg";
import CommonNavbar from "../CommonNavbar";
import { Link, useNavigate } from "react-router";
import { FaChevronRight, FaHome } from "react-icons/fa";
import Footer from "../../home/Footer";
import Queryform from "../Queryform";
import Navbar from "../../home/Navbar";

const HermitYesno = () => {
    const navigate = useNavigate();
    const buttonClick = () => {
        navigate('/yes&no/tarot');
    }
    // Array of tarot predictions
    const tarotPredictions = [
        { heading: 'YES', prediction: "The Hermit advises introspection and seeking truth within. A yes answer here indicates that solitude or independent reflection will lead to the clarity and insight you need to move forward. By embracing inner wisdom, you will discover the solution that’s best for you." },
        { heading: 'NO', prediction: "The Hermit may suggest that the answer lies within yourself, but you aren’t ready to look deeply or take action yet. A no could indicate the need for more self-exploration before making a decision. Rushing into something now might lead to more confusion." }
    ];

    // Function to randomly select a tarot prediction
    const getRandomPrediction = () => {
        const randomIndex = Math.floor(Math.random() * tarotPredictions.length);
        return tarotPredictions[randomIndex];
    };

    // Get a random tarot prediction to display
    const selectedPrediction = getRandomPrediction();
    return (
        <>
            <section className='bg-gradient-to-r from-white to-success/40 text-gray-900 min-h-screen'>
                <div>
                    <Navbar />
                </div>
                <div className='text-gray-900 flex flex-col items-center mt-12'>
                    <h1 className='text-3xl font-serif text-secondary font-bold mb-2'>YES/NO TAROT</h1>
                </div>
                <div className="w-full max-w-3xl text-sm text-gray-600 flex flex-wrap justify-center sm:justify-start items-center mt-6 px-4 sm:px-8">
                    <Link to={'/'}>
                        <FaHome className="mr-2 text-gray-700" />
                    </Link>
                    <Link to={'/tarot'} className="text-secondary hover:underline">TAROT</Link>
                    <FaChevronRight className="mx-2" />
                    <Link to={'/yes&no/tarot'} className="text-secondary hover:underline">YES/NO TAROT</Link>
                    <FaChevronRight className="mx-2" />
                    <span className="text-gray-700 font-semibold">HERMIT CARD</span>
                </div>
                <main className="flex items-center mt-10 justify-center text-center">
                    <div className="max-w-5xl w-full flex flex-col items-center justify-center text-center lg:flex-row gap-8">
                        {/* Card Section */}
                        <div className="flex flex-col shadow-md items-center lg:items-start">
                            <div className=" rounded-lg p-6 bg-transparent flex flex-col justify-center items-center w-80">
                                <div className="">
                                    {/* Tarot Card Image */}
                                    <img
                                        src={hermit}
                                        alt="The World Tarot Card"
                                        className="w-full h-auto object-cover"
                                    />
                                    {/* Title at the bottom of the card */}
                                    <div className="  text-center text-primary font-bold text-lg">
                                        THE HERMIT
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Description Section */}
                        <div className="flex-1">
                            <h2 className="text-2xl font-bold mb-4">The HERMIT</h2>
                            {/* Display selected random prediction */}
                            <h3 className="text-xl font-bold mx-2 text-start mb-1">{selectedPrediction.heading}</h3>
                            <p className="text-gray-600 mb-6 mx-2 text-justify leading-relaxed">{selectedPrediction.prediction}</p>
                            <div className="mb-6">
                                <p className="text-sm text-gray-500">
                                    Learn more about Tarot
                                    <a href="/learn" className="text-blue-500 ml-1 underline">
                                        Click here.
                                    </a>
                                </p>
                            </div>
                            {/* Button */}
                            <button onClick={buttonClick} className="bg-gray-900 text-white py-2 px-20 rounded-lg font-semibold shadow-md hover:bg-secondary transition duration-300">
                                Pick Another Card
                            </button>
                        </div>
                    </div>
                </main>
                <Queryform />
                <Footer />
            </section>
        </>
    )
}

export default HermitYesno